import 'core-js';
import 'webrtc-adapter';

import ReactDOM from "react-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import App from "./components/App";
import ErrorFallback from "./components/ErrorFallback";
import apiClient from "./constants/apiClient";
import * as serviceWorker from './serviceWorker';
import store from "./store";
import "./styles/style.scss";
export const version = process.env.REACT_APP_VERSION || "dev";
const logError = (error, info) => {
  console.error('Error caught by ErrorBoundary:', error);
  console.error('Component stack:', info.componentStack);

  // Enhanced error object with source information
  const errorDetails = {
    error: {
      name: error.name,
      message: error.message,
      version
    },
    stack: error.stack,
    componentStack: info.componentStack
  };

  console.log('Full error details for backend logging:', errorDetails);

  // Send to backend
  apiClient.post('/log-error', errorDetails)
    .then(response => {
      console.log('Error logged successfully:', response.data);
    })
    .catch(err => {
      console.error('Failed to log error to backend:', err);
    });
};

ReactDOM.render(
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
        <Provider store={store}>
            <App />
        </Provider>
    </ErrorBoundary>,
    document.getElementById("root")
);

serviceWorker.unregister();